"use client";

import { Mail, Phone, MapPin } from "lucide-react";
import { useTranslations } from "next-intl";

export default function ContactPage() {
	const t = useTranslations();

	return (
		<main className="bg-background font-sans">
			<div className="pt-[calc(4rem+env(safe-area-inset-top))] md:pt-20"></div>
			<div className="container-std mx-auto px-6 py-12 max-w-4xl space-y-10">
				<h1 className="text-4xl md:text-6xl font-black text-foreground tracking-tight">{t("legal_contact")}</h1>

				<div className="space-y-8 text-muted-foreground leading-relaxed text-lg">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
						<div className="p-8 material-regular rounded-3xl border border-white/10">
							<div className="w-12 h-12 bg-primary/20 rounded-xl flex items-center justify-center text-primary mb-6">
								<Mail size={24} />
							</div>
							<h3 className="text-xl font-bold text-foreground mb-2">{t("contact_email_title")}</h3>
							<a href="mailto:support@kinofolio.com" className="text-lg font-medium text-primary hover:underline">
								support@kinofolio.com
							</a>
						</div>

						<div className="p-8 material-regular rounded-3xl border border-white/10">
							<div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center text-purple-400 mb-6">
								<Phone size={24} />
							</div>
							<h3 className="text-xl font-bold text-foreground mb-2">{t("contact_phone_title")}</h3>
							<a href="tel:+74957205262" className="text-lg font-medium text-foreground hover:text-primary transition-colors">
								+7 (495) 720-52-62
							</a>
						</div>
					</div>

					<div className="mt-12 p-8 material-regular rounded-3xl border border-white/10">
						<div className="flex items-start gap-4">
							<MapPin className="text-muted-foreground mt-1 shrink-0" />
							<div>
								<h3 className="text-lg font-bold text-foreground mb-2">{t("contact_office_title")}</h3>
								<p className="text-muted-foreground">
									г. Москва, муниципальный округ Филевский Парк,
									<br />
									ул. 2-Я Филевская, д. 7, к. 6, помещ. 166
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}
